const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    matic: {
        id: 'matic',
        type: REFERENCE_ASSETS.MATIC,
        symbol: 'MATIC',
        decimals: 1e18,
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    },
    wmatic: {
        id: 'wmatic',
        type: REFERENCE_ASSETS.MATIC,
        symbol: 'WMATIC',
        decimals: 1e18,
        address: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
        coingeckoId: 'wmatic',
    },
    dai: {
        id: 'dai',
        coingeckoId: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        decimals: 1e18,
        address: '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063',
    },
    adai: {
        id: 'adai',
        coingeckoId: 'aave-dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aDAI',
        decimals: 1e18,
        address: '0x27F8D03b3a2196956ED754baDc28D73be8830A6e',
        wrappedCoinType: 'aave',
    },
    usdc: {
        id: 'usdc',
        coingeckoId: 'usd-coin',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
    },
    ausdc: {
        id: 'ausdc',
        coingeckoId: 'aave-usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aUSDC',
        decimals: 1e6,
        address: '0x1a13F4Ca1d028320A707D99520AbFefca3998b7F',
        wrappedCoinType: 'aave',
    },
    usdt: {
        id: 'usdt',
        coingeckoId: 'tether',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
    },
    ausdt: {
        id: 'ausdt',
        coingeckoId: 'aave-usdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aUSDT',
        decimals: 1e6,
        address: '0x60D55F02A771d515e077c9C2403a1ef324885CeC',
        wrappedCoinType: 'aave',
    },
    wbtc: {
        id: 'wbtc',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'wBTC',
        decimals: 1e8,
        address: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    },
    weth: {
        id: 'weth',
        coingeckoId: 'ethereum',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'WETH',
        decimals: 1e18,
        address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    },
    amwbtc: {
        id: 'amwbtc',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'amWBTC',
        decimals: 1e8,
        address: '0x5c2ed810328349100A66B82b78a1791B101C9D61',
        wrappedCoinType: 'aave',
    },
    amweth: {
        id: 'amweth',
        coingeckoId: 'ethereum',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'amWETH',
        decimals: 1e18,
        address: '0x28424507fefb6f7f8E9D3860F56504E4e5f5f390',
        wrappedCoinType: 'aave',
    },
    renbtc: {
        id: 'renbtc',
        coingeckoId: 'renbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'renBTC',
        decimals: 1e8,
        address: '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
    },
    atricrv: {
        id: 'atricrv',
        coingeckoId: 'lp-3pool-curve',
        type: REFERENCE_ASSETS.USD,
        symbol: 'a3Crv',
        decimals: 1e18,
        address: '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        isLpToken: true,
    },
    eurt: {
        id: 'eurt',
        coingeckoId: 'tether-eurt',
        type: REFERENCE_ASSETS.EUR,
        symbol: 'EURt',
        decimals: 1e6,
        address: '0x7BDF330f423Ea880FF95fC41A280fD5eCFD3D09f',
    },
    eurs: {
        id: 'eurs',
        coingeckoId: 'stasis-eurs',
        type: REFERENCE_ASSETS.EUR,
        symbol: 'EURS',
        decimals: 1e2,
        address: '0xE111178A87A3BFf0c8d18DECBa5798827539Ae99',
    },
};
